export function Footer() {
    return (
      <footer className="flex h-16 w-full items-center px-4 md:px-6 border-t">
        <p className="text-xs text-gray-500 dark:text-gray-400">© 2024 LiveStream ML. All rights reserved.</p>
      </footer>
    )
  }